import { Component, EventEmitter, Output, inject } from '@angular/core';
import { FormGroup, FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SmartwatchDashboardConfiguration } from './smartwatch-dashboard-configuration';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-smartwatch-dashboard-form',
    templateUrl: './smartwatch-dashboard-form.component.html',
    imports: [
        FormsModule,
        ReactiveFormsModule,
        TranslatePipe,
    ],
})
export class SmartwatchDashboardFormComponent {
  //TODO: Check why any is here
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data = inject<SmartwatchDashboardConfiguration>('formData' as any);
  private fb = inject(FormBuilder);

  form: FormGroup;

  @Output() dataChange = new EventEmitter<SmartwatchDashboardConfiguration>();

  constructor() {
    const data = this.data;

    this.form = this.fb.group({
      title: [data.title || ''],
      description: [data.description || ''],
    });
    this.form.valueChanges.subscribe((value) => {
      this.dataChange.emit(value);
    });
  }
}
